// extracted by mini-css-extract-plugin
export default {"charterBox":"charter_charterBox__A+rcD","leftBox":"charter_leftBox__Xy4Cz","rightBox":"charter_rightBox__6WhP3","titleBox":"charter_titleBox__Ll4Na"};